import { SectionState } from '../../../states/PromoPageState/state'
import { SectionDTO } from '../../../types/types'

export const getSectionReq = (sections: SectionState[]) => {
  const sectionsReq: SectionDTO[] = []

  sections.forEach((item, index) => {
    sectionsReq.push({
      type: item.type,
      title: item.title,
      index: index,
      content: item.content,
    })
  })

  return sectionsReq
}
